module.exports = __webpack_public_path__ + "img/tb_t305-91.prt.7fa61980.jpg";